module.exports = __webpack_public_path__ + "img/arrival_6.3ad1045e.jpg";